export enum PaymentOptionType {
    EVENTBRITE = 'eventbrite',
    OFFLINE = 'offline',
    PAYPAL = 'paypal',
    AUTHNET = 'authnet',
}

/* Types of payment methods (order service) */
export enum PaymentMethodType {
    NOT_SELECTED = '',
    BOLETO_BANCARIO = 'BOLETO_BANCARIO',
    CASH = 'CASH',
    CHECK = 'CHECK',
    CREDIT = 'CREDIT',
    FPP_PAYPAL = 'PAYPAL',
    IDEAL = 'IDEAL',
    INVOICE = 'INVOICE',
    MAESTRO_BANCONTACT = 'MAESTRO_BANCONTACT',
    NONCE_BRAINTREE = 'NONCE_BRAINTREE',
    SEPA_DIRECT_DEBIT = 'SEPA_DIRECT_DEBIT',
    SOFORT = 'SOFORT',
    USER_INSTRUMENT = 'USER_INSTRUMENT',
    BARCODE = 'BARCODE',
    RAPIPAGO = 'RAPIPAGO',
    PAGOFACIL = 'PAGOFACIL',
    OXXO = 'OXXO',
    AUTHNET = 'AUTHNET',
    APPLE_PAY = 'APPLE_PAY',
    GOOGLE_PAY = 'GOOGLE_PAY',
    STRIPE_CONFIRMATION_TOKEN = 'STRIPE_CONFIRMATION_TOKEN',
}

export const ALL_PAYMENT_METHOD_TYPES = [
    PaymentMethodType.BOLETO_BANCARIO,
    PaymentMethodType.CASH,
    PaymentMethodType.CHECK,
    PaymentMethodType.CREDIT,
    PaymentMethodType.FPP_PAYPAL,
    PaymentMethodType.IDEAL,
    PaymentMethodType.INVOICE,
    PaymentMethodType.MAESTRO_BANCONTACT,
    PaymentMethodType.NONCE_BRAINTREE,
    PaymentMethodType.SEPA_DIRECT_DEBIT,
    PaymentMethodType.SOFORT,
    PaymentMethodType.USER_INSTRUMENT,
    PaymentMethodType.BARCODE,
    PaymentMethodType.RAPIPAGO,
    PaymentMethodType.PAGOFACIL,
    PaymentMethodType.OXXO,
    PaymentMethodType.AUTHNET,
    PaymentMethodType.APPLE_PAY,
    PaymentMethodType.GOOGLE_PAY,
    PaymentMethodType.STRIPE_CONFIRMATION_TOKEN,
];

export enum PaymentConstraintName {
    ADYEN_POS_PAYMENT = 'ADYEN_POS_PAYMENT',
    AMEX = 'AMEX',
    BOLETO_BANCARIO = 'BOLETO_BANCARIO',
    BRAINTREE_APPLE_PAY = 'BRAINTREE_APPLE_PAY',
    BRAINTREE_GOOGLE_PAY = 'BRAINTREE_GOOGLE_PAY',
    BRAINTREE_PAYPAL = 'BRAINTREE_PAYPAL',
    CREDIT_CARD = 'CREDIT_CARD',
    DEBIT_CARD = 'DEBIT_CARD',
    DINERS_CLUB = 'DINERS_CLUB',
    DISCOVER = 'DISCOVER',
    ELO = 'ELO',
    HIPERCARD = 'HIPERCARD',
    IDEAL = 'IDEAL',
    MAESTRO = 'MAESTRO',
    MAESTRO_BANCONTACT = 'MAESTRO_BANCONTACT',
    MASTERCARD = 'MASTERCARD',
    MERCADO_PAGO = 'MERCADO_PAGO',
    MONERIS = 'MONERIS',
    NARANJA = 'NARANJA',
    NATIVA = 'NATIVA',
    OXXO = 'OXXO',
    PAGOFACIL = 'PAGOFACIL',
    RAPIPAGO = 'RAPIPAGO',
    SEPA_DIRECT_DEBIT = 'SEPA_DIRECT_DEBIT',
    SOFORT = 'SOFORT',
    VISA = 'VISA',
    VISA_DEBIT = 'VISA_DEBIT',
    BARCODE = 'BARCODE',
}

export enum InstrumentType {
    CREDIT_CARD = 'CREDIT_CARD',
    NONCE_BRAINTREE = 'NONCE_BRAINTREE',
    VIRTUAL_INCENTIVES_CARD = 'VIRTUAL_INCENTIVES_CARD',
}

export const EVENTBRITE_LEGACY_PAYMENT_METHODS = [
    PaymentMethodType.CREDIT,
    PaymentMethodType.APPLE_PAY,
    PaymentMethodType.GOOGLE_PAY,
    PaymentMethodType.NONCE_BRAINTREE,
];
